<script>
export default {
    name: 'ThreeDotsContentCook',
};
</script>

<script setup>
import { useRoute } from 'vue-router';

import { PL_ROUTE_NAMES } from '@/enums/routesNameEnums';
import { TIMELINE_VIEW_MODES } from '@/enums/timelineEnums';
import GroupedSettings from '@/components/constructions/grouped-settings';

defineProps({
    viewMode: {
        type: String,
        required: true,
    },
});

const route = useRoute();
</script>

<template>
    <GroupedSettings.Root>
        <GroupedSettings.List title="View mode">
            <GroupedSettings.ListItem :is-selected="viewMode === TIMELINE_VIEW_MODES.MAIN">
                <router-link
                    :to="{
                        name: PL_ROUTE_NAMES.INDEX,
                        query: { date: route.query.date },
                    }"
                >
                    By item
                </router-link>
            </GroupedSettings.ListItem>

            <GroupedSettings.ListItem :is-selected="viewMode === TIMELINE_VIEW_MODES.SECONDARY">
                <router-link
                    :to="{
                        name: PL_ROUTE_NAMES.SECONDARY_VIEW,
                        query: { date: route.query.date },
                    }"
                >
                    By order
                </router-link>
            </GroupedSettings.ListItem>
        </GroupedSettings.List>
    </GroupedSettings.Root>
</template>
